import { Info } from "lucide-react";
import React from "react";
import { Button } from "~/atoms/button";

interface Props {
  onClick?: (e: React.MouseEvent) => void;
}

export const InfoIconButton = React.forwardRef<HTMLButtonElement, Props>(
  ({ onClick }, ref) => {
    return (
      <Button ref={ref} onClick={onClick} variant="outline" size="icon">
        <Info />
      </Button>
    );
  },
);

InfoIconButton.displayName = "InfoIconButton";
